import PropTypes from 'prop-types';
import { Stack } from '@mui/material';

function ScansPanel({
    panel,
}) {
    return (
        <div className="viewer-left-panel">
            <Stack className="scans" direction="column">
                <div className="scans-header">
                    <h3>{panel.title}</h3>
                    <button
                        type="button"
                        className="scans-reset-button"
                        onClick={panel.onResetAllScans}
                        disabled={!panel.canResetScans}
                        aria-label={panel.resetButtonTitle}
                        title={panel.resetButtonTitle}
                    >
                        {panel.resetButtonLabel}
                    </button>
                </div>
                {panel.rows.map((row) => (
                    <div key={row.id} className={`scan-row-shell ${row.hasLoadFailure ? 'load-failed' : ''}`}>
                        <button
                            type="button"
                            className={`${row.isChecked ? 'checked' : ''} ${row.isAvailable ? 'available' : ''} ${row.hasLoadFailure ? 'failed' : ''} scan`}
                            disabled={!row.isAvailable}
                            title={row.title}
                            onClick={row.onToggleVisible}
                        >
                            <span className="scan-check" aria-hidden="true" />
                            <span className="scan-label">{row.label}</span>
                        </button>

                        {row.statusText && (
                            <div className="scan-row-status">{row.statusText}</div>
                        )}
                    </div>
                ))}
            </Stack>
        </div>
    );
}

ScansPanel.propTypes = {
    panel: PropTypes.shape({
        canResetScans: PropTypes.bool.isRequired,
        onResetAllScans: PropTypes.func.isRequired,
        resetButtonLabel: PropTypes.string.isRequired,
        resetButtonTitle: PropTypes.string.isRequired,
        rows: PropTypes.arrayOf(
            PropTypes.shape({
                hasLoadFailure: PropTypes.bool.isRequired,
                id: PropTypes.string.isRequired,
                isAvailable: PropTypes.bool.isRequired,
                isChecked: PropTypes.bool.isRequired,
                label: PropTypes.string.isRequired,
                onToggleVisible: PropTypes.func.isRequired,
                statusText: PropTypes.string,
                title: PropTypes.string,
            }),
        ).isRequired,
        title: PropTypes.string.isRequired,
    }).isRequired,
};

export default ScansPanel;
